import React from 'react';

import ReactModal from 'react-modal';
import Aux from '../../../hoc/ReactAux/ReactAux';
import checkMark from 'images/check-mark.png';
import timeUtils from 'utils/time';
import './modalReceiptTest.scss';

const customStyles = {
  content: {
    background: 'none',
    border: 'none',
    height: '100%',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    overflowY: 'scroll',
  },
  overlay: {
    position: 'fixed',
    zIndex: '9999999',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
  },
};

const Product = props => {
  return (
    <div className="bloco">
      <div className="wrapper">
        <strong className="left">{props.name}</strong>
        <strong className="right">{props.price}</strong>
      </div>
      <span>{props.description}</span>
    </div>
  );
};

const ResumeLine = props => {
  const classes = !!props.bold ? 'wrapper total' : 'wrapper';
  return props.showResume ? (
    <div className={classes}>
      <div className="left">{props.name}</div>
      <div className="right">{props.value}</div>
    </div>
  ) : null;
};

const CustomerDetails = ({
  firstName,
  lastName,
  businessName,
  isCollection,
  address,
}) => {
  let customerName = `${firstName} ${lastName}`;
  return (
    <div className="head">
      <strong>
        {isCollection
          ? `Collection by ${customerName}`
          : `Delivery to ${customerName}, ${businessName} @ ${address.street}`}
      </strong>
    </div>
  );
};

const OrderDateDetails = ({ cart, isCollection }) => {
  return (
    <Aux>
      {!!cart && !!cart.orderDeliveryDate && isCollection
        ? `Time for collection : ${timeUtils.formatDateToDateTimeAmPm(
            cart.orderDeliveryDate
          )}`
        : `Date: ${timeUtils.formatDateToDateTimeAmPm(cart.orderDeliveryDate)}`}
    </Aux>
  );
};

const modalReceipt = props => {
  if (!props.showModal) {
    return null;
  }

  const renderProduct = (item, currency, index) => {
    return (
      <Product
        key={index}
        name={item.name}
        price={`${currency} ${Number(item.price).toFixed(2)}`}
        description={`${item.description || ''} ${item.calory || ''}`}
      />
    );
  };

  const total = () => {
    return props.data.total === props.data.subtotal && props.data.tipValue > 0
      ? props.data.total + props.data.tipValue
      : props.data.total;
  };

  return (
    <Aux>
      <ReactModal
        isOpen={true}
        style={customStyles}
        onRequestClose={props.closeModal}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        contentLabel="Example Modal"
      >
        <div id="lb-receipt" className="lb-geral lb-receipt_">
          <div className="modal-content modal-content-receipt" tabIndex={0}>
            <button
              type="button"
              className="bt-close mfp-close lb-fechar fa fa-times"
              onClick={props.closeModal}
            />
            <div className="check-mark">
              <img src={checkMark} alt="" />
            </div>
            <div className="lb-content">
              <span className="order">
                <strong>Order {props.data.cart.idOrder}</strong>
                <br />
                <strong>has been placed.</strong>
              </span>
              <div className="purchase">
                <h3>Receipt</h3>
                <strong className="thank-you">
                  Thank you for your purchase,{' '}
                  {props.data.userDetails.firstName} :)
                </strong>
                <span className="order-date">
                  Order {props.data.cart.idOrder}
                  <br />
                  <OrderDateDetails
                    cart={props.data.cart}
                    isCollection={props.data.forCollection === 'Y'}
                  />
                </span>
                <div className="delivery">
                  <CustomerDetails
                    businessName={props.data.userDetails.businessName}
                    firstName={props.data.userDetails.firstName}
                    lastName={props.data.userDetails.lastName}
                    isCollection={props.data.forCollection === 'Y'}
                    address={props.data.address}
                  />
                  <div className="content">
                    {props.data.cart.products.map((product, index) =>
                      renderProduct(product, props.data.currency, index)
                    )}
                  </div>
                  <div className="foot">
                    <ResumeLine
                      showResume={true}
                      name="Subtotal"
                      value={`${props.data.currency} ${Number(
                        props.data.subtotal
                      ).toFixed(2)}`}
                    />
                    <ResumeLine
                      showResume={props.data.orderDeliveryDate !== undefined}
                      name="Tip"
                      value={`${props.data.currency} ${Number(
                        props.data.tipValue
                      ).toFixed(2)}`}
                    />
                    <ResumeLine
                      showResume={
                        props.data.forCollection === 'N' &&
                        props.data.orderDeliveryDate !== undefined
                      }
                      name="Subsidy"
                      value={`${props.data.currency} ${Number(
                        props.data.cart.subsidy
                      ).toFixed(2)}`}
                    />
                    <ResumeLine
                      showResume={
                        props.data.forCollection === 'N' &&
                        props.data.orderDeliveryDate !== undefined
                      }
                      name="Tax Delivery"
                      value={`${props.data.currency} ${Number(
                        props.data.taxDelivery
                      ).toFixed(2)}`}
                    />
                    <ResumeLine
                      showResume={props.data.forCollection === 'Y'}
                      name="Collection Discount"
                      value={`${props.data.collectionDiscount}`}
                    />
                    {!!props.data.surcharge && (
                      <ResumeLine
                        showResume={true}
                        name="Surcharge"
                        value={`${props.data.currency} ${Number(
                          props.data.surcharge
                        ).toFixed(2)}`}
                      />
                    )}
                    <ResumeLine
                      showResume={true}
                      name="Total"
                      value={`${props.data.currency} ${Number(total()).toFixed(
                        2
                      )}`}
                      bold={true}
                    />
                  </div>
                </div>
              </div>
              <a onClick={props.closeModal} className="bt">
                Got it
              </a>
            </div>
          </div>
        </div>
      </ReactModal>
    </Aux>
  );
};

export default modalReceipt;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalReceipt.js